// Libraries
import React, { useEffect } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'

// Components
import InitPage from 'components/Routes/InitPage'
import SitePolicies from 'components/Routes/SitePolicies'
import MainDashboard from 'components/Routes/MainDashboard'
import NoMatchPage from 'components/Routes/noMatchPage/NoMatchPage'
import SecureRoute from 'components/security/SecureRoute'
import NotificationBar from 'components/commons/NotificationBar'
import Spinner from 'components/commons/Spinner'
import PortalModal from 'components/commons/PortalModal'

// Services
import AuthorizedURLService from 'services/AuthorizedURLService'
import { useStateValue } from 'context/store'

// Styles
import theme from 'theme/theme'
import './App.css'
import { closeModalAction } from 'context/reducers/modalReducer'

const authorizedUrlService = new AuthorizedURLService()

const App = () => {
   const [{ sessionUser = {}, openSpinner = {}, openSnackbar = {}, openModal = {} }, dispatch] = useStateValue()

   useEffect(() => {
      authorizedUrlService.validateStoredMenu(dispatch, sessionUser.settings)
   }, [])

   return (
      <>
         <CssBaseline />
         {openSpinner.open && <Spinner />}
         {openSnackbar.open && <NotificationBar />}
         <BrowserRouter>
            <MuiThemeProvider theme={theme}>
               <div id="AppContainer">
                  <Switch>
                     <SecureRoute exact path="/site-policies" component={SitePolicies} />
                     <SecureRoute path="/dashboard" component={MainDashboard} />
                     <Route path="/">
                        <InitPage />
                     </Route>
                     <Route>
                        <NoMatchPage />
                     </Route>
                  </Switch>
               </div>
            </MuiThemeProvider>
         </BrowserRouter>
         {openModal?.message && <PortalModal params={openModal} onClose={() => dispatch(closeModalAction())} />}
      </>
   )
}

export default App
